import axios from "axios";

interface ApiErrorBody {
  message?: string;
  error?: string;
  errors?: Array<string | { message?: string }>;
}

const isApiErrorBody = (value: unknown): value is ApiErrorBody => {
  return typeof value === "object" && value !== null;
};

const readApiErrorMessage = (data: unknown): string | undefined => {
  if (!isApiErrorBody(data)) return undefined;

  if (typeof data.message === "string" && data.message.trim()) {
    return data.message;
  }

  if (typeof data.error === "string" && data.error.trim()) {
    return data.error;
  }

  if (Array.isArray(data.errors)) {
    const firstError = data.errors.find(Boolean);
    if (typeof firstError === "string" && firstError.trim()) {
      return firstError;
    }
    if (
      isApiErrorBody(firstError) &&
      typeof firstError.message === "string" &&
      firstError.message.trim()
    ) {
      return firstError.message;
    }
  }

  return undefined;
};

export const getApiErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (axios.isAxiosError(error)) {
    return readApiErrorMessage(error.response?.data) ?? error.message ?? fallback;
  }

  return error instanceof Error ? error.message : fallback;
};
